// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "app-oficina" + "." + "8fa1384b" + ".chunk.css";
};